import api from "../../index";

export const GetClientsApi = () => api.post('clientlist');
export const GetClientByIdApi = (data) => api.post('clientinfo', data);
export const AddClientTagApi = (data) => api.post('add-client-tag', data);
export const DeleteClientApi = (data) => api.post('delete-client', data);
export const ChangeClientStatusApi = (data) => api.post('change-user-status', data);
export const ExportClientsApi = (data, headers) => api.post('export-clients', data, headers);

// Documents
export const GetClientDocumentsApi = (data) => api.post('filefolderlist', data);
export const DownloadFileFolderApi = (data, headers) => api.post('download-file-folder', data, headers);
export const GetChildFolderListApi = (data) => api.post('viewfilefolder', data);
export const DeleteFileFolderApi = (data) => api.post('deletefilefolder', data);
export const UploadFileFolderApi = (data, headers) => api.post('uploadfilefolder', data, headers);
export const MoveFileFolderApi = (data) => api.post('movefilefolder', data);

// Organizer
export const GetClientOrganizerApi = (data) => api.post('client-org-list', data);

// Invoice
export const GetClientInvoice = (data) => api.post('invoice-list', data);

// Notes
export const ViewClientNoteApi = (data) => api.post('view-client-note', data);
export const SendNoteToClientApi = (data) => api.post('save-note-to-client', data);

// Referral
export const GetReferralListApi = (data) => api.post('referraluserlist', data);

// Communication
export const GetOrganizerListApi = (data) => api.post('clientorganizerlist', data);
export const CreateChatApi = (data) => api.post('chatcreate', data);
export const GetActiveChatApi = (data) => api.post('chatroomsbydate', data);
export const GetArchiveChatApi = (data) => api.post('archivechatlist', data);
export const GetMessageListApi = (data) => api.post('chatmessageslist', data);